import {
  Box,
  Button,
  Collapse,
  IconButton,
  InputAdornment,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import ClearIcon from "@mui/icons-material/Clear";
import { Key, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import {
  AllCourses,
  CourseViewModel,
  UsersEnCourse,
  UsersEnrolledCourse,
} from "@mikros/library";
import ApiServices from "../../service/apiService";
import Account from "../../utils/apiConfig";
import { CourseUserViewModel } from "@mikros/library/src/model";
import ErrorHandler from "../../utils/errorConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";
import { useNavigate } from "react-router-dom";

export function CourseViewDuplicate() {
  // Example: Accessing a course and its user profile
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });

  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const navigate = useNavigate();

  const [allCourses, setAllCourses] = useState<AllCourses>({
    resources: [],
    resourceCount: 0,
  });

  const [searchText, setSearchText] = useState<string>("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchClick, setSearchClick] = useState<boolean>(false);
  const [searchActive, setSearchActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<any>("");
  const [hasMoreData, setHasMoreData] = useState(true); // Track if more data is available
  const [totalCourseCount, setTotalCourseCount] = useState<number>(0);

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("error code flag value print", errorFlag);

  console.log("search active value", searchActive);

  const delChannelConvert = (channel: string) => {
    if (channel === "WHATSAPP") {
      return intl.formatMessage({ id: "analytics.courseView.whatsApp" });
    } else if (channel === "TEAMS") {
      return intl.formatMessage({ id: "analytics.courseView.teams" });
    }
  };

  // Replace underscores with spaces
  const toTitleCase = (text: string) =>
    text
      ?.toLowerCase()
      ?.replace(/_/g, " ")
      ?.split(" ")
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      ?.join(" ");

  const dateFormatFunc = (dateString: string) => {
    if (!dateString) {
      return intl.formatMessage({ id: "naValue" });
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return intl.formatMessage({ id: "naValue" });
    }
    const day = String(date.getDate()).padStart(2, "0"); //ensures 2  digit day
    const months = [
      intl.formatMessage({ id: "janValue" }),
      intl.formatMessage({ id: "febValue" }),
      intl.formatMessage({ id: "marValue" }),
      intl.formatMessage({ id: "aprValue" }),
      intl.formatMessage({ id: "mayValue" }),
      intl.formatMessage({ id: "junValue" }),
      intl.formatMessage({ id: "julValue" }),
      intl.formatMessage({ id: "augValue" }),
      intl.formatMessage({ id: "septValue" }),
      intl.formatMessage({ id: "octValue" }),
      intl.formatMessage({ id: "novValue" }),
      intl.formatMessage({ id: "decValue" }),
    ];
    const month = months[date.getMonth()]; // Get the month name

    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;

    //format time as hh:mm AM/PM (local time without seconds)
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm =
      hours >= 12
        ? intl.formatMessage({ id: "pmValue" })
        : intl.formatMessage({ id: "amValue" });
    hours = hours % 12; // to convert 24-format to 12-hour format
    hours = hours ? hours : 12; //to handle 0 hour
    const formattedTime = `${hours}:${minutes} ${ampm}`;
    return `${formattedDate} at ${formattedTime}`;
  };

  const handleClear = () => {
    setSearchText("");

    if (searchClick) {
      // fetchAllCourses(rowsPerPage, lastKey); // Reusable function for fetching all courses
      const api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            // `${accountInstance.accntId}/analytics/courseAnalytics/filter`,
            `${accountInstance.accntId}/course/getPublishedCourses?limit=20`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              console.log("Received published courses : ",data)
              //   setCourseModelData(data);
              setAllCourses(data);
              //   setTotalCourseCount(data?.courses?.length);
              setTotalCourseCount(data?.resources?.length);

              // setSearchActive(true);
              setSearchActive(false);
              setHasMoreData(true);
            }
          });
      }
      setSearchClick(false);
    }
  };

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    const trimmedSearchText = searchText.trim();

    if (trimmedSearchText === "") return; // Prevent API call if only spaces

    setSearchClick(true);
    const queryString = `courseName=${encodeURIComponent(trimmedSearchText)}`;

    const api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequest(
          `${accountInstance.accntId}/analytics/courseAnalytics/filter?${queryString}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // setCourseModelData(data);
            setAllCourses(data);

            // setTotalCourseCount(data?.courses?.length);
            setTotalCourseCount(data?.resources?.length);
            setSearchActive(true);
            const hasDataLeft = data?.lastKey !== null;
            setHasMoreData(hasDataLeft);
          }
        });
    }
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");
    console.log("loading value", loading);
    console.log("search active value", searchActive);
    if (!loading && !searchActive) {
      console.log("changing to page", newPage);
      console.log("last key print in handle change page", lastKey);
      console.log("print page", newPage, "last key", lastKey);
      fetchAllCourses(rowsPerPage, lastKey);
    }
  };
  // const handleRowsPerPageChange = (event: { target: { value: string } }) => {
  //   setSearchText("");
  //   const newRowsPerPage = parseInt(event.target.value, 10);
  //   console.log("rows per page change value", newRowsPerPage);
  //   // setRowsPerPage(parseInt(event.target.value, 10));
  //   setRowsPerPage(newRowsPerPage);
  //   setPage(0); // Reset to first page when rows per page changes
  //   setLastKey(null);
  //   setSearchActive(false);
  //   fetchAllCourses(newRowsPerPage, "");
  // };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value", newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    if (!searchActive) {
      setSearchText("");
      setPage(0);
      setLastKey(null);
      setSearchActive(false);
      fetchAllCourses(newRowsPerPage, "");
    }
  };

  //   type CourseDataType = (typeof courseModelData.courses)[number];
  type CourseDataType = (typeof allCourses.resources)[number];

  //   const paginatedData = searchActive
  //     ? rowsPerPage === -1
  //       ? courseModelData?.courses // Display all records when rowsPerPage = -1
  //       : courseModelData?.courses?.slice(
  //           page * rowsPerPage,
  //           page * rowsPerPage + rowsPerPage
  //         ) // Frontend pagination
  //     : rowsPerPage === -1
  //     ? courseModelData?.courses // API-based pagination
  //     : courseModelData?.courses?.slice(
  //         page * rowsPerPage,
  //         page * rowsPerPage + rowsPerPage
  //       );

  const paginatedData = searchActive
    ? rowsPerPage === -1
      ? allCourses?.resources // Display all records when rowsPerPage = -1
      : allCourses?.resources?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        ) // Frontend pagination
    : rowsPerPage === -1
    ? allCourses?.resources // API-based pagination
    : allCourses?.resources?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

  //   const totalPages =
  //     courseModelData?.courses?.length > 0
  //       ? Math.ceil(courseModelData?.courses?.length / rowsPerPage)
  //       : 1;

  const totalPages =
    allCourses?.resources?.length > 0
      ? Math.ceil(allCourses?.resources?.length / rowsPerPage)
      : 1;

  console.log("paginated data print", paginatedData);
  //   const fetchAllCourses = async (limit: number, key: string) => {
  //     const api = ApiServices.getInstance();

  //     if (limit === -1) {
  //       setLoading(true);
  //       console.log("inside limit equal -1");
  //       api
  //         .makeRequest(
  //           `${accountInstance.accntId}/analytics/courseAnalytics`,
  //           "GET"
  //         )
  //         .then(async (data) => {
  //           if (data && data.errorMessage) {
  //             console.log("I entered error code handling in users");
  //             setErrorFlag(true);
  //             await errorInstance.updateErrorCode(data.errorMessage);
  //             return;
  //           } else {
  //             setCourseModelData(data);
  //             const totalCourseCount = data?.courses?.length;
  //             setTotalCourseCount(totalCourseCount);
  //             setLoading(false);
  //           }
  //         });
  //       return;
  //     }
  //     if (accountInstance.accntId && key === "") {
  //       setLoading(true);
  //       console.log("entered when last key is null");
  //       api
  //         .makeRequest(
  //           `${accountInstance.accntId}/analytics/courseAnalytics?limit=${limit}`,
  //           "GET"
  //         )
  //         .then(async (data) => {
  //           if (data && data.errorMessage) {
  //             console.log("I entered error code handling in users");
  //             setErrorFlag(true);
  //             await errorInstance.updateErrorCode(data.errorMessage);
  //             return;
  //           } else {
  //             setCourseModelData(data);
  //             const totalCourseCount = data?.courses?.length;
  //             setTotalCourseCount(totalCourseCount);
  //             setLastKey(data.lastKey);
  //             setHasMoreData(!!data.lastKey);
  //             setLoading(false);
  //           }
  //         });
  //     } else if (accountInstance.accntId && key !== null) {
  //       setLoading(true);
  //       console.log("fetching next page with last key", key);
  //       api
  //         .makeRequest(
  //           `${accountInstance.accntId}/analytics/courseAnalytics?limit=${limit}&lastKey=${key}`,
  //           "GET"
  //         )
  //         .then(async (data) => {
  //           if (data && data.errorMessage) {
  //             console.log("I entered error code handling in users");
  //             setErrorFlag(true);
  //             await errorInstance.updateErrorCode(data.errorMessage);
  //             return;
  //           } else {
  //             setCourseModelData((prevData: any) => ({
  //               ...prevData,
  //               courses: [...(prevData?.courses || []), ...data.courses],
  //             }));

  //             setTotalCourseCount(
  //               (prevCount: any) => prevCount + (data?.courses?.length || 0)
  //             );
  //             setLastKey(data.lastKey);
  //             setHasMoreData(!!data.lastKey);
  //             setLoading(false);
  //           }
  //         });
  //     }
  //   };

  const fetchAllCourses = async (limit: number, key: string) => {
    const api = ApiServices.getInstance();

    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/course`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // setCourseModelData(data);
            setAllCourses(data);
            // const totalCourseCount = data?.courses?.length;
            const totalCourseCount = data?.resources?.length;
            setTotalCourseCount(totalCourseCount);
            setLoading(false);
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);
      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/course/getPublishedCourses?limit=${limit}`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // setCourseModelData(data);
            setAllCourses(data);
            // const totalCourseCount = data?.courses?.length;
            const totalCourseCount = data?.resources?.length;
            setTotalCourseCount(totalCourseCount);
            setLastKey(data.lastKey);
            setHasMoreData(!!data.lastKey);
            setLoading(false);
          }
        });
    } else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("fetching next page with last key", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/course/getPublishedCourses?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log("I entered error code handling in users");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            setAllCourses((prevData: AllCourses) => ({
              ...prevData,
              resources: [...(prevData?.resources || []), ...data.resources],
              resourceCount:
                prevData.resourceCount + (data.resources?.length || 0),
            }));

            // setTotalCourseCount(
            //   (prevCount: any) => prevCount + (data?.courses?.length || 0)
            // );
            setTotalCourseCount(
              (prevCount: any) => prevCount + (data?.resources?.length || 0)
            );
            setLastKey(data.lastKey);
            setHasMoreData(!!data.lastKey);
            setLoading(false);
          }
        });
    }
  };

  function Row(props: { row: CourseDataType }) {
    const { row } = props;
    const [open, setOpen] = useState(false);
    const [userEnrolledCourse, setUserEnrolledCourse] =
      useState<UsersEnrolledCourse>({
        users: [],
      });

    const [loading, setLoading] = useState(false);
    const [dataFetched, setDataFetched] = useState(false);

    // Inner table sorting state
    const [innerSortField, setInnerSortField] = useState<string>("name");
    const [innerSortDir, setInnerSortDir] = useState<"asc" | "desc">("asc");

    const handleInnerSort = (field: string) => {
      if (innerSortField === field) {
        setInnerSortDir((prev) => (prev === "asc" ? "desc" : "asc"));
      } else {
        setInnerSortField(field);
        setInnerSortDir("asc");
      }
    };

    const getComparableValue = (detail: any, field: string) => {
      switch (field) {
        case "name":
          return `${detail?.userProfile?.firstName || ""} ${detail?.userProfile?.lastName || ""}`.trim().toLowerCase();
        case "status":
          return (detail?.status || "").toString().toLowerCase();
        case "startDate":
          return detail?.startDate ? new Date(detail.startDate).getTime() : Number.NEGATIVE_INFINITY;
        case "completedTime":
          return detail?.completedTime ? new Date(detail.completedTime).getTime() : Number.NEGATIVE_INFINITY;
        case "channel":
          return Array.isArray(detail?.channels)
            ? detail.channels.join(",").toString().toLowerCase()
            : "";
        case "userProgress":
          return typeof detail?.userProgress === "number" ? detail.userProgress : Number.NEGATIVE_INFINITY;
        case "courseScore":
          return typeof detail?.courseScore === "number" ? detail.courseScore : Number.NEGATIVE_INFINITY;
        default:
          return "";
      }
    };

    const sortedUsers = [...(userEnrolledCourse.users || [])].sort((a, b) => {
      const av = getComparableValue(a, innerSortField);
      const bv = getComparableValue(b, innerSortField);
      if (av < bv) return innerSortDir === "asc" ? -1 : 1;
      if (av > bv) return innerSortDir === "asc" ? 1 : -1;
      return 0;
    });

    const fetchUserEnrolledCourse = async () => {
      if (dataFetched) {
        return;
      }
      setLoading(true);
      try {
        const api = ApiServices.getInstance();
        const response = await api
          .makeRequest(
            `${accountInstance.accntId}/analytics/courseAnalytics?courseId=${row.courseId}`,
            "GET"
          )
          .then(async (response) => {
            if (response && response.errorMessage) {
              console.log(
                "entered error code handling in user enrolled course"
              );
              setErrorFlag(true);
              await errorInstance.updateErrorCode(response.errorMessage);
              return;
            } else {
              setUserEnrolledCourse(response);
              setDataFetched(true); //mark data as fetched
            }
          });
      } catch (error) {
        console.error("error fetching user enrolled course", error);
      } finally {
        setLoading(false);
      }
    };

    const handleExpandRow = () => {
      setOpen(!open);
      console.log("open value in handle expand row", open);
      if (!open) {
        fetchUserEnrolledCourse();
      }
    };
    console.log("open value", open);
    console.log("user enrolled course", userEnrolledCourse);

    return (
      <>
        <TableRow
          sx={{
            "&>*": {
              borderBottom: open ? "none" : "1px solid rgba(224,224,224,1)",
            },
            backgroundColor: open
              ? "transparent"
              : "var(--color-mk-primary-20)",
            "&:hover": open
              ? {
                  backgroundColor: "#FFF !important",
                }
              : {},
          }}
        >
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              //   onClick={() => setOpen(!open)}
              onClick={handleExpandRow}
              disableRipple
              disableFocusRipple
              style={{ backgroundColor: "transparent" }}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                },
                "&:focus": {
                  bacgroundColor: "transparent",
                },
              }}
            >
              {open ? (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 hover:cursor-pointer text-mk-primary ${
                    open ? "rotate-90" : ""
                  }`}
                />
              ) : (
                <FontAwesomeIcon
                  icon={["fas", "fa-play" as IconName]}
                  className={`h-5 w-4.5 mx-3 hover:cursor-pointer text-mk-primary`}
                />
              )}
            </IconButton>
          </TableCell>

          <TableCell>{row.courseName}</TableCell>
          <TableCell>{toTitleCase(row.status)}</TableCell>
          <TableCell>{row.chapterCount}</TableCell>
          <TableCell>{row.cardCount}</TableCell>
          <TableCell>
            {row.createdAt ? dateFormatFunc(row.createdAt) : "N/A"}
          </TableCell>
        </TableRow>

        <TableRow
          sx={{
            "&>*": {
              borderBottom: open ? "20px solid #F5F6FD !important" : "none",
              boxShadow: open ? "0px 4px 10px rgba(0,0,0,0.1)" : "none",
            },
            "&:hover": {
              backgroundColor: "#FFF! important",
            },
            marginBottom: open ? "16px" : "0",
            boxShadow: open ? "0px 4px 8px rgba(0, 0, 0, 0.1)" : "none", // Shadow effect when open
            padding: open ? "16px" : "0", // Optional padding inside the row when open
            borderRadius: open ? "8px" : "0", // Optional: rounded corners when ope
            zIndex: open ? 1 : "auto", // Brings the expanded row to the front
          }}
        >
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={2}>
                <Table
                  size="small"
                  aria-label="user details"
                  sx={{
                    "&:hover": {
                      backgroundColor: "#FFF !important",
                    },
                  }}
                >
                  <TableHead
                    sx={{
                      backgroundColor: "#FFF",
                      // "&:hover": {
                      //   backgroundColor: "transparent !important",
                      // },
                      "& .MuiTableRow-root:hover": {
                        background: "var(--color-mk-white) !important",
                      },
                      "&:hover": {
                        backgroundColor: "var(--color-mk-white) !important",
                      },
                    }}
                  >
                    <TableRow
                      sx={{
                        "&:hover": {
                          backgroundColor: "#FFF !important",
                        },
                      }}
                    >
                      <TableCell onClick={() => handleInnerSort("name")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.userName" />
                        {" "}
                        {innerSortField === "name" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("status")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.userCourseStatus" /> {innerSortField === "status" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("startDate")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.startDate" /> {innerSortField === "startDate" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("completedTime")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.completionDate" /> {innerSortField === "completedTime" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("channel")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.deliveryChannel" /> {innerSortField === "channel" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("userProgress")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.userProgress" /> {innerSortField === "userProgress" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                      <TableCell onClick={() => handleInnerSort("courseScore")} sx={{ cursor: "pointer" }}>
                        <FormattedMessage id="analytics.courseView.assessmentScore" /> {innerSortField === "courseScore" ? (innerSortDir === "asc" ? "▲" : "▼") : "↕"}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "&:hover": {
                        backgroundColor: "#FFF !important",
                      },
                    }}
                  >
                    {/* {row.users.length > 0 ? (
                      row.users.map(
                        (
                          detail: UsersEnCourse,
                          index: Key | null | undefined
                        ) => (
                          <TableRow
                            key={index}
                            sx={{
                              border: "none",
                              backgroundColor: "mk-white",
                              "&:hover": {
                                backgroundColor: "#FFF !important", // Sets the background color to white on hover
                              },
                            }}
                          >
                            <TableCell sx={{ border: "none" }}>
                              {detail.name}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {toTitleCase(detail.status)}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {dateFormatFunc(detail.startDate)}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {dateFormatFunc(detail.completedTime)}
                            </TableCell>

                            <TableCell sx={{ border: "none" }}>
                              {delChannelConvert(detail.channel)}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {detail.userProgress}
                              {"%"}
                            </TableCell>
                            <TableCell sx={{ border: "none" }}>
                              {detail.courseScore}
                              {"%"}
                            </TableCell>
                          </TableRow>
                        )
                      )
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          sx={{
                            textAlign: "center",
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <FormattedMessage id="analytics.courseView.noUser" />
                        </TableCell>
                      </TableRow>
                    )} */}

                    {sortedUsers.length > 0 ? (
                      sortedUsers.map((detail, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <TableCell sx={{ border: "none" }}>
                            {/* {detail.name} */}
                            {detail.userProfile.firstName}{" "}
                            {detail.userProfile.lastName}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {toTitleCase(detail.status)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {dateFormatFunc(detail.startDate)}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.completedTime
                              ? dateFormatFunc(detail.completedTime)
                              : "N/A"}
                          </TableCell>

                          <TableCell sx={{ border: "none" }}>
                            {delChannelConvert(detail.channels.join(","))}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.userProgress}
                            {"%"}
                          </TableCell>
                          <TableCell sx={{ border: "none" }}>
                            {detail.courseScore
                              ? `${detail.courseScore}%`
                              : "N/A"}
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell
                          colSpan={7}
                          sx={{
                            textAlign: "center",
                            border: "none",
                            backgroundColor: "mk-white",
                            "&:hover": {
                              backgroundColor: "#FFF !important", // Sets the background color to white on hover
                            },
                          }}
                        >
                          <FormattedMessage id="analytics.courseView.noUser" />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }

  console.log("course details print", allCourses);
  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  useEffect(() => {
    if (searchText === "" && searchClick) {
      handleClear();
    }
  }, [searchText, searchClick]);

  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);

  useEffect(() => {
    // let api = ApiServices.getInstance();

    if (accountInstance.accntId) {
      // api
      //   .makeRequest(
      //     `${accountInstance.accntId}/analytics/courseAnalytics`,
      //     "GET"
      //   )
      //   .then(async (data) => {
      //     setCourseModelData(data);
      //   });
      fetchAllCourses(rowsPerPage, lastKey);
    }
  }, [accountInstance.accntId]);

  return (
    <div className="mt-6">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              if (errorInstance.permDenied === true) {
                navigate("/home");
              } else {
                // navigate("/analytics");
                navigate("/reports");
              }
            }}
          />
        </Dialog>
      )}
      <div className="flex items-center space-x-8">
        <div className="text-mk-primary-bright text-xl font-semibold">
          <FormattedMessage id="analytics.courseView.searchCourse" />
        </div>
        <TextField
          variant="outlined"
          placeholder="Course Name"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            style: { backgroundColor: "white" },
            startAdornment: (
              <InputAdornment position="start">
                {searchText.trim() && (
                  <Button
                    size="small"
                    type="submit"
                    variant="contained"
                    disableRipple
                    // disabled={searchText.trim() === ""}
                    sx={{
                      // mt: 2,
                      borderRadius: "4px",
                      textTransform: "capitalize",
                      color: "white",

                      backgroundColor: "var(--color-mk-primary-bright)",
                      "&:hover": {
                        backgroundColor: "#E1E2E9",
                        color: "black",
                      },
                      display: "inline-block",
                      height: "24px",
                      padding: "2px 8px",
                      // minHeight: "16px !important", // Set minimum height
                    }}
                    onClick={handleSearch}
                  >
                    <FormattedMessage id="searchButton" />
                  </Button>
                )}
              </InputAdornment>
            ),

            endAdornment: (
              <InputAdornment position="end">
                {searchText && (
                  <IconButton onClick={handleClear} edge="end" size="small">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div className="pb-8"></div>

      <TableContainer component={Paper} elevation={0}>
        <Table size="medium" aria-label="collapsible table">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "#F5F6FD !important",
                },
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              }}
            >
              <TableCell
                sx={{
                  width: "3%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              />
              <TableCell
                sx={{
                  width: "25%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.courseView.courseName"></FormattedMessage>
              </TableCell>
              <TableCell
                sx={{
                  width: "15%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.courseView.courseStatus"></FormattedMessage>
              </TableCell>
              <TableCell
                sx={{
                  width: "15%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.courseView.chaptCount" />
              </TableCell>
              <TableCell
                sx={{
                  width: "15%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.courseView.cardsCount" />
              </TableCell>
              <TableCell
                sx={{
                  width: "15%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                <FormattedMessage id="analytics.courseView.courseCreationDate" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData?.length > 0 ? (
              paginatedData?.map((row: any, index: Key | null | undefined) => (
                <Row key={index} row={row} />
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="courses.noCourses" />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            backgroundColor: "#F5F6FD",
            padding: 0, //removes padding
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text"
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        !hasMoreData &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        !hasMoreData &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>
            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              // count={courseModelData?.courses.length}
              count={totalCourseCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} 
               
                      ${intl.formatMessage({ id: "ofValue" })}
                       ${count}
                       ${intl.formatMessage({ id: "items" })}
                        `
              }
              ActionsComponent={() => null} // to remove navigation buttons
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>
    </div>
  );
}
